module.exports = __webpack_public_path__ + "static/media/train7.4ed85ece.png";